import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducer/index';
import './styles/index.css';
import './styles/variables.scss';
import './utils/Result';
import './utils/InternalLinks';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';

const options = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducer,
  options(applyMiddleware(thunk)),
);

window.result.setStore(store);

ReactDOM.render(
  React.createElement(
    Provider,
    { store },
    React.createElement(ToastProvider, null, React.createElement(App)),
  ),
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
